/*
 * Arrastrar con el ratón las fotos de la ficha de producto (y las miniaturas), como se hace con el dedo
 * en el móvil. El carrusel ya es un scroll con scroll-snap: aquí solo se traduce el arrastre del ratón
 * en scroll y, al soltar, se encaja en la foto más cercana. Con táctil o lápiz el navegador ya lo hace.
 */
(function () {
  'use strict';

  var THRESHOLD = 5; // px antes de considerar que es un arrastre y no un clic

  function slidesOf(slider) {
    return Array.prototype.filter.call(slider.children, function (el) {
      return el.offsetWidth > 0;
    });
  }

  function nearestIndex(slider, slides) {
    var best = 0;
    var dist = Infinity;
    for (var i = 0; i < slides.length; i += 1) {
      var d = Math.abs(slides[i].offsetLeft - slider.scrollLeft);
      if (d < dist) {
        dist = d;
        best = i;
      }
    }
    return best;
  }

  function enable(slider, snapToSlide) {
    if (!slider || slider.dataset.hmDrag === '1') return;
    slider.dataset.hmDrag = '1';
    slider.classList.add('hm-draggable');

    var down = false;
    var moved = false;
    var startX = 0;
    var startLeft = 0;
    var startIndex = 0;
    var savedBehavior = '';

    slider.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth + 1) return;
      down = true;
      moved = false;
      startX = event.clientX;
      startLeft = slider.scrollLeft;
      startIndex = snapToSlide ? nearestIndex(slider, slidesOf(slider)) : 0;
    });

    window.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < THRESHOLD) return;
        moved = true;
        slider.classList.add('is-dragging');
        savedBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.style.scrollSnapType = 'none';
      }
      event.preventDefault();
      slider.scrollLeft = startLeft - dx;
    });

    function release(event) {
      if (!down) return;
      down = false;
      if (!moved) return;
      slider.classList.remove('is-dragging');
      var dx = event.clientX - startX;
      slider.style.scrollBehavior = savedBehavior;
      if (snapToSlide) {
        var slides = slidesOf(slider);
        var index = nearestIndex(slider, slides);
        // Un arrastre corto pero decidido pasa a la foto siguiente o anterior.
        if (index === startIndex && Math.abs(dx) > 40) {
          index = Math.max(0, Math.min(slides.length - 1, startIndex + (dx < 0 ? 1 : -1)));
        }
        slider.style.scrollSnapType = '';
        if (slides[index]) slider.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      } else {
        slider.style.scrollSnapType = '';
      }
      // El clic que sigue a un arrastre no debe abrir el zoom de la foto.
      var swallow = function (clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      };
      slider.addEventListener('click', swallow, { capture: true, once: true });
      setTimeout(function () {
        slider.removeEventListener('click', swallow, true);
      }, 0);
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    // Sin esto el navegador arrastra la imagen como un archivo en lugar de deslizar el carrusel.
    slider.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      enable(gallery.querySelector('[id^="Slider-Gallery"]'), true);
      enable(gallery.querySelector('[id^="Slider-Thumbnails"]'), false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
